import { FC, PropsWithChildren } from "react"
import { Navigate, Outlet } from "react-router"

import { pathConstants } from "../pathConstants"
import LoadingPage from "./LoadingPage"

type ProtectedRouteProps = {
  redirectPath?: string
  isLoading: boolean
  isAuthenticated: boolean
}

export const ProtectedRoute: FC<PropsWithChildren<ProtectedRouteProps>> = ({
  redirectPath = pathConstants.login,
  isLoading,
  isAuthenticated,
  children,
}) => {
  let childName = children && (children as any).type?.name
  console.log(
    `[ProtectedRoute] navigating to protected route${
      childName ? ` with child: ${childName}` : ""
    }`,
  )

  if (isLoading) {
    return <LoadingPage />
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return children ? children : <Outlet />
}
